export default [
    {
        number: "378.3K",
        title: "Facebook Fans",
        icon: "facebook"
    },
    {
        number: "510.4K",
        title: "Facebook Followers",
        icon: "facebook"
    },
    {
        number: "213K",
        title: "Instagram Followers",
        icon: "instagram"
    },
    {
        number: "44.7K",
        title: "Youtube Subscribers",
        icon: "youtube-white-green"
    },
    {
        number: "1.1K",
        title: "Twitter Followers",
        icon: "twitter"
    }
];
